import React from "react";
import { BaseLayout } from "../../layouts/";
import { FarmerProfile } from "../../components";
import { FarmerProfilePageStyled } from "./FarmerProfilePageStyled";
var FarmerProfilePage = function (props) {
    return (React.createElement(BaseLayout, null,
        React.createElement(FarmerProfilePageStyled, null,
            React.createElement(FarmerProfile, null))));
};
export default FarmerProfilePage;
//# sourceMappingURL=FarmerProfilePage.js.map